import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { usePermissions } from 'hooks';
import { StepsLoading } from 'pages/public/Loading';
import NotFoundPage from 'pages/public/NotFoundPage';

import AudienceCreatePage from './pages/AudienceCreatePage';
import AudienceEditPage from './pages/AudienceEditPage';
import AudienceListPage from './pages/AudienceListPage';
import AudienceShowPage from './pages/AudienceShowPage';

const Audiences = () => {
  const { canEdit, canView } = usePermissions('audiences');
  return (
    <Suspense fallback={<StepsLoading />}>
      <Routes>
        <Route index element={<Navigate to="list" replace />} />
        {canView && <Route path="list" element={<AudienceListPage />} />}
        {canEdit && <Route path="create" element={<AudienceCreatePage />} />}
        {canView && <Route path="show/:id" element={<AudienceShowPage />} />}
        {canEdit && <Route path="edit/:id" element={<AudienceEditPage />} />}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};

export default Audiences;
